import { type ApiOnboardingStep, LocalOnboardingStep } from '@/onboarding/types'
import type { Vertical } from '@/types/verticals'

/**
 * Mapping of api step name to onboarding url path / route name
 */
export const ONBOARDING_MAPPED_API_STEPS: Record<
  Vertical.Fish,
  { [key in ApiOnboardingStep]?: LocalOnboardingStep }
> = Object.freeze({
  fish: {},
})

// Default fallback onboarding steps
export const DEFAULT_ONBOARDING_STEPS: Record<
  Vertical.Fish,
  LocalOnboardingStep[]
> = {
  fish: [LocalOnboardingStep.SupportedArea, LocalOnboardingStep.Autosubscribe],
}

// Required onboarding steps
export const REQUIRED_ONBOARDING_STEPS: Record<
  Vertical.Fish,
  LocalOnboardingStep[]
> = {
  fish: [],
}

export const LAND_SELECTION = [
  {
    id: 'public',
    name: 'Public',
  },
  {
    id: 'private',
    name: 'Private',
  },
]
